export default [
  {
    path: "cota-evento",
    name: "eventPhotoQuota",
    component: () => import("@/views/cabine/EventPhotoQuota.vue"),
  },
  {
    path: "codigo-evento",
    name: "eventCode",
    component: () => import("@/views/cabine/EventCode.vue"),
  },
  {
    path: "home",
    name: "homeCabine",
    component: () => import("@/views/cabine/home.vue"),
  },
  {
    path: "selecione-tipo-foto",
    name: "selectTypePhoto",
    component: () => import("@/views/cabine/photoTypeSelect.vue"),
  },
  {
    path: "selecione-modo-captura",
    name: "selectModeCapture",
    component: () => import("@/views/cabine/modoCapturaSelect.vue"),
  },
  {
    path: "selecione-qtd-foto",
    name: "selectQtdPhoto",
    component: () => import("@/views/cabine/photoQtdSelect.vue"),
  },
  {
    path: "scan-qr-code",
    name: "scanQrCode",
    component: () => import("@/views/cabine/scanQrCode.vue"),
  },
  {
    path: "selfie",
    name: "selfie",
    component: () => import("@/views/cabine/selfie/vSelfie.vue"),
  },
  {
    path: "aguardando-upload",
    name: "aguardandoUpload",
    component: () => import("@/views/cabine/aguardandoUpload.vue"),
  },
  {
    path: "editor",
    name: "editorDeFotos",
    component: () => import("@/views/cabine/editor/vEditor.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "seleciona-pagamento",
    name: "Metodo de pagamento DEB/CRED",
    component: () =>
      import("@/views/cabine/pagamento/SelecionaMetodoDePagamento.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "pagamento-em-processo",
    name: "Pagamento em processo",
    component: () => import("@/views/cabine/pagamento/ProcessoDePagamento.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "pagamento-sucesso",
    name: "SucessoPagamento",
    component: () => import("@/views/cabine/pagamento/vPagamentoSucesso.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "pagamento-falha",
    name: "Falha no pagamento",
    component: () => import("@/views/cabine/pagamento/falha.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "impressao",
    name: "impressao",
    component: () => import("@/views/cabine/impressora/vImpressao.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    path: "agradecimento",
    name: "agradecimento",
    component: () => import("@/views/cabine/agradecimento.vue"),
    meta: { showAssistanceActions: true },
  },
  {
    // Rota filha desconhecida dentro de /cabine. Antes apontava para "/home",
    // que não existe no router — caía no wildcard raiz e mandava o totem para
    // o /404 em vez de voltar para a Home.
    path: "*",
    name: "nada",
    redirect: "/cabine/home",
  },
];
